import Vue from 'vue';
import AcronisUiKit from '@uikit/ui-kit';
import svgSpritePath from '@uikit/ui-syntax/dist/svg-sprite/symbol/svg/sprite.symbol.svg';

Vue.use(AcronisUiKit, { svgSpritePath });
